import React, { Component } from "react";
import { connect } from "react-redux";
import "./styles.scss";
import "./mobile.scss";
import {
  ButtonIcon,
  FilterColor_1,
  FilterColor_2,
  InfoCard,
} from "../../../../components";
import { GetIcon } from "../../../../config/icon";
import Footer from "../../../Footer";
import { Helmet } from "react-helmet";
import SeoContent from "../../../templates/SeoContent";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wizardNo: 1,
      registeredType: 1,
      viewPointWidth: 0,
      viewPointHeight: 0,
      wizardStep: 1,
      isLoading: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      viewPointWidth: window.innerWidth,
      viewPointHeight: window.innerHeight,
    });
  }

  handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    console.log("scrollTop : " + scrollTop);
    console.log("scrollHeight : " + scrollHeight);
    console.log("clientHeight :" + clientHeight);
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("scroll", this.handleOnScroll);
    // this.props.getAllRecentTransfers();
    //this.props.getAllFavouritesTransfers();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
  }
  render() {
    const { viewPointHeight, isLoading } = this.state;
    const { isMoreInfo, onClick } = this.props;

    return (
      <>
        <Helmet>
          <title>About us - Best Credit Card Offers in Sri Lanka</title>
          <meta
            name="description"
            content="Learn more about our mission to help you find the best credit card offers in Sri Lanka. Explore exclusive deals, promotions, and savings tailored for you."
          />
          <link
            rel="canonical"
            href="https://www.creditcardoffers.lk/about-us"
          />
        </Helmet>

        {/* About Us */}
        <div className={"mim__about"}>
          <div className={"mim__header"}>
            <div className={"container"}>
              <div className={"d-flex flex-row"}>
                <ButtonIcon
                  type={"back"}
                  onClick={() => this.props.history.push("/")}
                  size={"lg-x"}
                  buttonIcon={GetIcon("leftArrow")}
                />

                <div className={"mimh__title"}>FAQ </div>
              </div>
            </div>
          </div>
          {/* Top Wrapper */}

          <div className={"container"}>
            <SeoContent />
          </div>

          {/* get in touch */}
          <div className={"mima__get-touch"}>
            <div className={"mima__gt__title"}>Get in Touch</div>
            <div className={"mima__gt__content"}>
              Ready to discover the best credit card offers? Visit
              CreditCardOffers.lk or contact us at
              <span className={"mima__gtc__email"}>info@difynbest.com</span>
              for more information. Follow us on social media for the latest
              updates and exclusive offers.
            </div>
          </div>
          <div className={"mim__footer"}>
            <Footer />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
